if (!customElements.get('fwd-product-tabs')) {
  customElements.define(
    'fwd-product-tabs',
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        if (!this.tabs.length) return;

        this.onClick = this.handleClick.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
      }

      handleClick(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;
        this.activate(tab, true);
      }

      handleKeydown(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;

        const currentIndex = this.tabs.indexOf(tab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        if (nextIndex !== currentIndex) {
          event.preventDefault();
          this.moveFocus(this.tabs[nextIndex]);
          return;
        }

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.activate(tab, true);
        }
      }

      moveFocus(nextTab) {
        this.tabs.forEach((tab) => tab.setAttribute('tabindex', tab === nextTab ? '0' : '-1'));
        nextTab.focus();
      }

      activate(nextTab, moveFocus) {
        const panelId = nextTab.getAttribute('aria-controls');

        this.tabs.forEach((tab) => {
          const active = tab === nextTab;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.setAttribute('tabindex', active ? '0' : '-1');
        });

        this.panels.forEach((panel) => {
          const active = panel.id === panelId;
          panel.hidden = !active;
          panel.inert = !active;
          panel.classList.toggle('is-active', active);
          if (active) {
            panel.getAnimations().forEach((animation) => animation.cancel());
            panel.animate(
              [
                { opacity: 0, transform: 'translateY(4px)' },
                { opacity: 1, transform: 'translateY(0)' },
              ],
              {
                duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 160,
                easing: 'ease-out',
              }
            );
          }
        });

        if (moveFocus) nextTab.focus();
      }
    }
  );
}
